<template>
  <div class="assignTask box-border">
    <div class="flex">
      <div class="left pt-4" :style="{ flex:'auto',width: 'calc(100% - 330px)' }">
        <div style="height: calc(100vh - 130px); overflow: auto" v-show="active === 1">
          <div class="visitor-info px-4">
            <div class="top-title font-bold">1.添加调查员</div>
            <el-form
              @validate="validatePhone"
              ref="visitorInfo"
              :model="visitorInfo"
              :rules="visitorInfoRules"
              label-width="140px"
              label-position="right"
            >
              <el-form-item class="input_phone" label="调查员手机号:" prop="executorPhone">
                <el-input style="width: 288px" v-model="visitorInfo.executorPhone" placeholder="请输入有效手机号"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <AddSampleList num="2." @selectionChangeEmit="selectionChangeEmit" ref="addSampleList"/>
        </div>
        <div class="task-info px-6" v-show="active === 2" style="height: calc(100vh - 130px); overflow: auto">
          <div class="top">任务信息</div>
          <el-form ref="taskInfo" :model="taskInfo" :rules="taskInfoRules" label-width="90px" label-position="right">
            <el-form-item :style="{ marginBottom: '0' }" label="结算类型：" prop="settleMethod">
              <div class="flex">
                <div class="inline-block">
                  <div class="btn-box btn1 box-border" :class="{ 'btn-checked': btnChecked == 'online' }" @click="changeSettleMethod('online')">
                    <el-checkbox class="position-checkbox" :disabled = "!(btnChecked == 'online')" :value="true"></el-checkbox>
                    <div>
                      <div class="text-theme-black-650 text-medium mb-2 font-semibold">线上结算
                        <div class="tujian bg-yellow-theme text-white inline-block text-center font-semibold text-small">
                          推荐
                        </div>
                      </div>
                      <div class="text-theme-black-450 text-small">线上支付调查员费用，调研工厂代调查员纳税，并为您的总花费开具发票</div>
                      <div class="flex justify-between mt-1" v-if="!isOpen">
                        <span class="text-yellow-theme text-small">
                          <i class="iconfont icon-jingshishuoming text-small font-semibold"></i>
                          尚未开通，无法使用
                        </span>
                        <span class="cursor-pointer text-theme text-small" @click="toOpen">去开通></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="inline-block">
                  <div class="btn-box btn2 box-border" :class="{ 'btn-checked': btnChecked == 'offline' }" @click="changeSettleMethod('offline')">
                    <el-checkbox class="position-checkbox" :disabled = "!(btnChecked == 'offline')" :value="true"></el-checkbox>
                    <div>
                      <div class="text-theme-black-650 text-medium mb-2 font-semibold">线下结算</div>
                      <div class="text-theme-black-450 text-small">常用场景：线下与调查员签署劳务协议、协商支付方式、纳税事宜等</div>
                    </div>
                  </div>
                </div>
                <div class="inline-block">
                  <div class="btn-box btn2 box-border" :class="{ 'btn-checked': btnChecked == 'neednot' }" @click="changeSettleMethod('neednot')">
                    <el-checkbox class="position-checkbox" :disabled = "!(btnChecked == 'neednot')" :value="true"></el-checkbox>
                    <div>
                      <div class="text-theme-black-650 text-medium mb-2 font-semibold">无需结算</div>
                      <div class="text-theme-black-450 text-small">常用场景：已同调查员签署劳动合同或调查员愿提供无偿服务等</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item :style="{ marginBottom: taskInfo.settleMode ? '0' : '18px' }" label="结算方式：" prop="settleMode">
              <el-radio-group v-model="taskInfo.settleMode" @change="changeSettlementType" :disabled="(!isOpen&&taskInfo.settleMethod==0)">
                <el-radio :label="1">按答卷数量</el-radio>
                <el-radio :label="2">按天</el-radio>
                <el-radio v-if="!(btnChecked == 'neednot')" :label="3">按阶梯计价</el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="settlementType-style" v-if="taskInfo.settleMode === 1">
              <div class="flex-box" v-if="taskInfo.settleMethod!=2">
                <el-form-item
                  label="单价:"
                  label-width="110px"
                  prop="settleRule.unitPriceYuan"
                  :rules="[{ required: !((!isOpen&&taskInfo.settleMethod==0)||taskInfo.settleMethod==2), message: ' ', trigger: 'blur' }]"
                >
                  <el-input-number
                    placeholder=""
                    v-model="taskInfo.settleRule.unitPriceYuan"
                    autocomplete="off"
                    controls-position="right"
                    :min="1"
                    :max="Infinity"
                    :precision="2"
                    :disabled="(!isOpen&&taskInfo.settleMethod==0)||taskInfo.settleMethod==2"
                  >
                  </el-input-number>
                </el-form-item>
                <span>元</span>
              </div>
              <div class="settlement-tips"  v-if="taskInfo.settleMethod!=2">
                若用线上结算，请填写调查员到手金额，到手金额
                <el-button type="text" @click="() => this.$emit('emitDialog', true)">计算器</el-button>
              </div>
              <div class="flex-box">
                <span class="pos-abs-box">
                  <i>*</i>
                  答卷数量:
                  <el-tooltip
                    effect="dark"
                    content="该数量仅为参考回收数量，调查员可超额上报答卷，您可与调查员线下协商上报数量，采用线上结算时，可按照实际上报答卷数量进行结算"
                    placement="top"
                  >
                    <div class="icon-wrap" style="margin-left: 4px">
                      <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                    </div>
                  </el-tooltip>
                </span>
                <el-form-item
                  label-width="110px"
                  label=""
                  prop="settleRule.expectedQuantity"
                  :rules="[{ required: !((!isOpen&&taskInfo.settleMethod==0)), message: ' ', trigger: 'blur' }]"
                >
                  <el-input-number
                    placeholder=""
                    v-model="taskInfo.settleRule.expectedQuantity"
                    autocomplete="off"
                    controls-position="right"
                    :min="1"
                    :max="Infinity"
                    :precision="0"
                    :disabled="(!isOpen&&taskInfo.settleMethod==0)"
                  >
                  </el-input-number>
                </el-form-item>
                <span>份</span>
              </div>
              <div class="settlement-tips" style="margin-bottom: 0"  v-if="taskInfo.settleMethod!=2">
                预估费用：{{ totalPriceYuan }}元，若采用{{btnChecked==='online' ? '线上':'线下'}}结算，项目预计花费 {{ totalSaleYuan }}元
              </div>
            </div>
            <div class="settlementType-style" v-if="taskInfo.settleMode === 2">
              <div class="flex-box"  v-if="taskInfo.settleMethod!=2">
                <el-form-item
                  label-width="110px"
                  label="单价:"
                  prop="settleRule.unitPriceYuan"
                  :rules="[{ required: !((!isOpen&&taskInfo.settleMethod==0)||taskInfo.settleMethod==2), message: ' ', trigger: 'blur' }]"
                >
                  <el-input-number
                    placeholder=""
                    v-model.number="taskInfo.settleRule.unitPriceYuan"
                    autocomplete="off"
                    controls-position="right"
                    :min="1"
                    :max="Infinity"
                    :precision="2"
                    :disabled="(!isOpen&&taskInfo.settleMethod==0)||taskInfo.settleMethod==2"
                  >
                  </el-input-number>
                </el-form-item>
                <span>元</span>
              </div>
              <div class="settlement-tips"  v-if="taskInfo.settleMethod!=2">
                若用线上结算，请填写调查员到手金额，到手金额
                <el-button type="text" @click="() => this.$emit('emitDialog', true)">计算器</el-button>
              </div>
              <div class="flex-box">
                <span class="pos-abs-box">
                  <i>*</i>
                  天数:
                  <el-tooltip
                    effect="dark"
                    content="当天只要上报答卷即记为工作 1 天，该天数仅为参考工作天数，您可与调查员线下协商工作天数，采用线上结算时，可按照实际工作天数进行结算"
                    placement="top"
                  >
                    <div class="icon-wrap" style="margin-left: 4px">
                      <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                    </div>
                  </el-tooltip>
                </span>
                <el-form-item
                  label=""
                  label-width="110px"
                  prop="settleRule.expectedQuantity"
                  :rules="[{ required: !((!isOpen&&taskInfo.settleMethod==0)), message: ' ', trigger: 'blur' }]"
                >
                  <el-input-number
                    placeholder=""
                    v-model.number="taskInfo.settleRule.expectedQuantity"
                    autocomplete="off"
                    controls-position="right"
                    :min="1"
                    :max="Infinity"
                    :precision="0"
                    :disabled="(!isOpen&&taskInfo.settleMethod==0)"
                  >
                  </el-input-number>
                </el-form-item>
                <span>天</span>
              </div>
              <div class="settlement-tips" style="margin-bottom: 0"  v-if="taskInfo.settleMethod!=2">
                <div style="display: flex">
                  <div>预估费用：{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalSaleYuan }}元</div>
                  <el-tooltip
                    effect="dark"
                    :content="`项目预计费用=预估费用*（1+${accRate}），其中${accountingRateVal}为用于调查员待缴税及平台技术服务费`"
                    placement="top"
                  >
                    <div class="icon-wrap">
                      <span class="icon-font ico-tips">&#xe65b;</span>
                    </div>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div class="settlementType-style" v-if="taskInfo.settleMode === 3">
              <el-form-item class="is-require-task" label-width="110px" style="margin-bottom: 0" label="单价:"  v-if="taskInfo.settleMethod!=2">
                <div
                  class="flex-settlement"
                  v-for="(item, index) in taskInfo.settleRule.tiers"
                  :key="index"
                  :style="{ marginBottom: index === taskInfo.settleRule.tiers.length - 1 ? '0px' : '5px' }"
                >
                  <span style="margin-right: 8px" v-show="index === 0">每天</span>
                  <el-form-item label>
                    <el-input-number
                      v-if="index === 0"
                      :disabled="true"
                      placeholder=""
                      v-model="item.quantityLowerBound"
                      autocomplete="off"
                      controls-position="right"
                      :min="0"
                      :max="Infinity"
                      :precision="0"
                    >
                    </el-input-number>
                    <el-input-number
                      v-if="index > 0"
                      :disabled="true"
                      placeholder=""
                      :value="taskInfo.settleRule.tiers[index - 1].quantityUpperBound"
                      autocomplete="off"
                      controls-position="right"
                      :min="0"
                      :max="Infinity"
                      :precision="0"
                    >
                    </el-input-number>
                  </el-form-item>
                  <span style="margin: 0 8px">份 &lt; 完成量 ≤</span>
                  <el-form-item
                    label
                    :prop="'settleRule.tiers[' + index + '].quantityUpperBound'"
                    :rules="[{ required: !((!isOpen&&taskInfo.settleMethod==0)||taskInfo.settleMethod==2), message: ' ', trigger: 'blur' }]"
                  >
                    <el-input-number
                      placeholder=""
                      v-model="item.quantityUpperBound"
                      autocomplete="off"
                      controls-position="right"
                      :min="index > 0 ? taskInfo.settleRule.tiers[index - 1].quantityUpperBound * 1 + 1 : 1"
                      :max="Infinity"
                      @change="val => currentInputNumber(val, item, index)"
                      :precision="0"
                      :disabled="(!isOpen&&taskInfo.settleMethod==0)||taskInfo.settleMethod==2"
                    >
                    </el-input-number>
                  </el-form-item>
                  <span style="margin: 0 8px">份，按完成量</span>
                  <el-form-item
                    label
                    :prop="'settleRule.tiers[' + index + '].unitPriceYuan'"
                    :rules="[
                      {
                        required: !((!isOpen&&taskInfo.settleMethod==0)||taskInfo.settleMethod==2),
                        message: ' ',
                        trigger: 'blur'
                      }
                    ]"
                    style="margin-left: 10px"
                  >
                    <el-input-number
                      placeholder=""
                      v-model.number="item.unitPriceYuan"
                      autocomplete="off"
                      controls-position="right"
                      :min="1"
                      :max="Infinity"
                      :precision="2"
                      :disabled="(!isOpen&&taskInfo.settleMethod==0)||taskInfo.settleMethod==2"
                    >
                    </el-input-number>
                  </el-form-item>
                  <span style="margin-left: 8px">元/份</span>
                  <el-button v-if="index === 0" @click="handleSettlement('add', index)" class="btn-style" type="text"
                    ><i class="icon-font">&#xe68c;</i></el-button
                  >
                  <el-button
                    v-else-if="index === taskInfo.settleRule.tiers.length - 1"
                    @click="handleSettlement('remove', index)"
                    class="btn-style"
                    type="text"
                    ><i class="icon-font">&#xe68a;</i></el-button
                  >
                </div>
                <div class="settlement-tips left-0">
                  若用线上结算，请填写调查员到手金额，到手金额
                  <el-button type="text" @click="() => this.$emit('emitDialog', true)">计算器</el-button>
                </div>
              </el-form-item>
              <div class="flex-box">
                <el-form-item
                  style="margin-bottom: 0"
                  label="天数:"
                  label-width="110px"
                  prop="settleRule.expectedQuantity"
                  :rules="[{ required: !((!isOpen&&taskInfo.settleMethod==0)), message: ' ', trigger: 'blur' }]"
                >
                  <el-input-number
                    placeholder=""
                    v-model.number="taskInfo.settleRule.expectedQuantity"
                    autocomplete="off"
                    controls-position="right"
                    :min="1"
                    :max="Infinity"
                    :precision="0"
                    :disabled="(!isOpen&&taskInfo.settleMethod==0)"
                  >
                  </el-input-number>
                </el-form-item>
                <span>天</span>
              </div>
            </div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="任务名称:" prop="executionName">
                  <el-input class="el-form-input" v-model="taskInfo.executionName" placeholder="指定样本面对面访问任务"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="截止时间:" prop="executionValidateTo">
                  <el-date-picker
                    class="el-form-input"
                    type="datetime"
                    placeholder="选择时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="taskInfo.executionValidateTo"
                    :picker-options="startDateDisabled"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="描述:">
              <el-input v-model="taskInfo.executionDescription" placeholder="请输入描述"></el-input>
            </el-form-item>
            <el-form-item label="执行要求:" prop="executionRequirement">
              <el-input placeholder="请输入执行要求" v-model="taskInfo.executionRequirement" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="质控标准:" prop="qualityControlStandard">
              <el-input v-model="taskInfo.qualityControlStandard" placeholder="请输入质控标准"></el-input>
            </el-form-item>
            <!-- <el-form-item label="结算标准:" prop="settleStandard">
              <el-input v-model="taskInfo.settleStandard" placeholder="请输入结算标准"></el-input>
            </el-form-item> -->
          </el-form>
        </div>
        <div class="btn-footer" v-show="active === 1">
          <el-button
            :type="canNextStep ? 'primary' : 'info'"
            :disabled="canNextStep ? false : true"
            @click="next()"
            style="width: 88px"
            >下一步</el-button
          >
          <el-button @click="cancel" style="width: 88px">取 消</el-button>
        </div>
        <div class="btn-footer" v-show="active === 2">
          <el-button size="small" @click="back" style="width: 88px">上一步</el-button>
          <el-button size="small" type="primary" @click="onClickSubmit" style="width: 88px">确认</el-button>
        </div>
      </div>
      <div class="right px-4 bg-card-bg-gray" :style="{ width: '290px',flex:'none'}">
        <div :style="{ overflow:'auto',height:'calc(100vh - 78px)' }">
          <Advert></Advert>
        </div>
      </div>
    </div>
    <OnlinePayService ref="onlinePayServiceVisible" />
  </div>
</template>

<script>
import ClickDelete from '@/components/PopConfirm.vue'
import { getSamplePage } from '@/api/wenjuan/sample'
import { getSamplePageList, getSampleGroup } from '@/api/wenjuan/sample_new.js'
import { isNum } from '@/assets/js/utils'
import { questionType } from '@dygc/question'
import OnlinePayService from '@/components/online-pay-service'
import { getCheckPhone, postAssignSampleOfflineTask } from '@/api/wenjuan/offline'
import { mapGetters } from 'vuex'
import { sampleOption, tableOption } from './option'
import GlobalConfig from '@/global/config'
import DataTable from '@/components/base/DataTable'
import { toWJB } from '@/assets/js/base-platform'
import Advert from '@/components/interview/advert/index.vue'
import AddSampleList from '@/views/survey/offline/components/drawer/AddSampleList'

const testNum = /((^[0-9]\d*)|^0)(\.\d{0,2})?$/
export default {
  name: 'assignTask',
  // components:{myInput},
  components: { OnlinePayService, DataTable, ClickDelete, Advert, AddSampleList },
  created() {
    if (this.title) {
      this.taskInfo.executionName = this.title + '-指定样本面访任务' + this.len // '面对面访问' + len
    } else {
      this.taskInfo.executionName = '指定样本面访任务' + this.len // '面对面访问' + len
    }
  },
  mounted() {
    this.isOpen = this.$store.getters.settlementType !== 1
  },
  props: {
    len: {
      type: Number,
      default: 1
    }
  },
  data() {
    const phoneReg = /^1(1|2|3|4|5|6|7|8|9)\d{9}$/
    // 正则 手机号，姓名
    const phoneNameReg = /^1(1|2|3|4|5|6|7|8|9)\d{9}[,，][\u4E00-\u9FA5A-Za-z\s]+(·[\u4E00-\u9FA5A-Za-z]+)*$/

    const phoneRules = async (rule, value, callback) => {
      let vPhone = this.visitorInfo.executorPhone
      // 手机号 或 手机号,姓名
      if (phoneReg.test(value) || phoneNameReg.test(value)) {
        // 1 通过第一层验证
        // 1.1 若手机号验证通过
        if (phoneReg.test(value)) {
          this.executorPhone = this.visitorInfo.executorPhone
          // 1.1.1验证数据库
          await getCheckPhone(vPhone)
            .then(res => {
              let data = res.data.data
              if (data.length) {
                // 1.1.1.1 数据库存在
                this.executionBy = data[0].id
                this.userName = data[0].name
                // console.log("名字：",data[0]);
              } else {
                // 1.1.1.2 数据库不存在
                callback(new Error('当前手机号不存在（非企业员工请同时输入调查员姓名，用逗号隔开）'))
              }
            })
            .catch(e => {
              console.log(e)
            })
        }

        // 1.2 若手机号,姓名 通过验证
        // 需要再次验证 手机号与姓名 是否在库中 以及 是否对应
        if (phoneNameReg.test(value)) {
          // 需要逗号分隔
          let m = vPhone.split(/[,，]/g)
          this.executorPhone = m[0]
          this.userName = m[1]
          // 验证 手机号与姓名 是否在库中 以及 是否对应
          await getCheckPhone(m[0])
            .then(res => {
              let newData = res.data.data
              if (newData.length) {
                // 数据库存在
                if (this.userName != newData[0].name) {
                  // callback(new Error('样本库不匹配'))
                  callback(new Error('员工姓名与已有信息不匹配，请删除姓名'))
                } else {
                }
              } else {
              }
            })
            .catch(e => {
              console.log(e)
            })
        }
      } else {
        // 2 未通过验证
        callback(new Error('请输入正确手机号'))
      }

      callback()
    }
    const executionNameRules = (rule, value, callback) => {
      let v = this.taskInfo.executionName
      if (!v.trim()) {
        callback(new Error('请输入任务名称'))
      }
      callback()
    }
    const executionSingleAmountRules = (rule, value, callback) => {
      let v = this.taskInfo[rule.fullField]
      if (!testNum.test(v)) {
        let _v = Number(v)
        // console.log(_v)
        if (!isNaN(_v)) {
          callback(new Error('最多支持两位小数'))
        } else {
          callback(new Error('请输入有效数字'))
        }
      }
      callback()
    }
    const executionValidateToRules = (rule, value, callback) => {
      let v = this.taskInfo.executionValidateTo
      if (!v) {
        callback(new Error('请选择结束时间'))
      }
      callback()
    }
    const startDateDisabled = {}
    startDateDisabled.disabledDate = function (time) {
      return time.getTime() + 24 * 3600 * 1000 < Date.now()
    }
    return {
      settleMethodMap: {
        'online':0,
        'offline':1,
        'neednot':2
      },
      btnCheckedMap: {
        0:'online',
        1:'offline',
        2:'neednot'
      },
      btnChecked: 'online',
      isOpen: false,
      GlobalConfig,
      active: 1,
      tableData: [], // table 的数据
      userName: '',
      VerifiedPhone: false,
      executorPhone: '',
      value: [],
      startDateDisabled,
      executionBy: '',
      visitorInfo: {
        executorPhone: ''
      },
      visitorInfoRules: {
        executorPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: phoneRules, trigger: 'change' },
          { validator: phoneRules, trigger: 'blur' }
        ]
      },
      taskInfo: {
        executionName: '',
        settleMethod: 0,
        settleMode: 1,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        },
        settleStandard:''
      },
      taskInfoRules: {
        executionName: [{ required: true, validator: executionNameRules, trigger: 'blur' }],
        // qualityControlStandard: [{ required: true, message:'请输入质控标准', trigger: 'blur' }],
        executionSingleAmount: [
          {
            required: true,
            validator: executionSingleAmountRules,
            trigger: 'blur'
          }
        ],
        executionValidateTo: [
          {
            required: true,
            validator: executionValidateToRules,
            trigger: 'blur'
          }
        ]
      },
    }
  },
  watch: {
    tableData() {
      this.taskInfo.executionQuantity = this.tableData.length
    }
  },
  computed: {
    canNextStep() {
      if (this.tableData.length > 0 && this.VerifiedPhone) {
        return true
      } else {
        return false
      }
    },
    ...mapGetters(['title']),
    sampleIdList() {
      let sampleIdList = this.tableData.map(obj => {
        return obj.id
      })
      return sampleIdList
    },
    totalPriceYuan () {
      if (this.taskInfo.settleRule.expectedQuantity && this.taskInfo.settleRule.unitPriceYuan) {
        return (this.taskInfo.settleRule.expectedQuantity * this.taskInfo.settleRule.unitPriceYuan).toFixed(2)
      } else {
        return 0
      }
    },
    totalSaleYuan () {
      if (this.taskInfo.settleRule.expectedQuantity && this.taskInfo.settleRule.unitPriceYuan) {
        return ((1 + this.accRate * 1) * (this.taskInfo.settleRule.expectedQuantity * this.taskInfo.settleRule.unitPriceYuan)).toFixed(2)
      } else {
        return 0
      }
    },
    accountingRateVal() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '6.5%' : `${accountingRate}%`
    },
    accRate() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '0.065' : (accountingRate / 100).toFixed(3)
    }
  },
  methods: {
    toOpen() {
      window.open(
        `${window.location.origin + process.env.VUE_APP_PRE_URL}/#/cost-settlement`
      )
    },
    changeSettleMethod(btnType) {
      this.btnChecked = btnType
      this.taskInfo.settleMethod = this.settleMethodMap[btnType]
      this.changeSettlementType(1)
    },
    //  phone 表单的 验证结果
    validatePhone() {
      // console.log("arguments",arguments[1]);
      if (arguments[1]) {
        this.VerifiedPhone = true
        // this.em
      } else {
        this.VerifiedPhone = false
      }
    },
    back() {
      this.active--
    },
    next() {
      this.active++
    },
    cancel() {
      this.$confirm('取消创建任务', {
        message: '确认放弃此次任务吗，取消后将不能恢复',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$emit('cancel')
        })
        .catch(() => {
          //几点取消的提示
        })
    },
    onClickSubmit() {
      if(!this.isOpen&&this.taskInfo.settleMethod==0) {
        this.$message({
          message: '尚未开通费用结算，无法设定线上结算',
          type: 'warning'
        });
        return
      }   
      let taskInfo = this.$refs.taskInfo
      let visitorInfo = this.$refs.visitorInfo
      let arr = [
        {
          vueComponent: taskInfo,
          // validateArr: ['executionName', 'executionQuantity', 'executionSingleAmount', 'executionValidateTo'],
          validateArr: ['executionName', 'executionSingleAmount', 'executionValidateTo']
        },
        {
          vueComponent: visitorInfo,
          validateArr: ['executorPhone']
        }
      ]
      let postData = {}
      if (this.taskInfo.settleMode === 3) {
        const cloneLadderSettlement = [...this.taskInfo.settleRule.tiers]
        cloneLadderSettlement.forEach((it, i, arr) => {
          if (i > 0) {
            it.quantityLowerBound = arr[i - 1].quantityUpperBound * 1
          }
        })
        postData = {
          ...this.taskInfo,
          settleRule: {
            ...this.taskInfo.settleRule,
            tiers: cloneLadderSettlement
          },
        }
        // postData.ladderSettlement =cloneLadderSettlement;
        this.taskInfo = { ...postData }
      }

      //  this.$refs.visitorInfo.validate((valid) => {
      //   if (valid) {
      this.$refs.taskInfo.validate(valid => {
        if (valid) {
          postAssignSampleOfflineTask({
            surveyId: GlobalConfig.getSurveyId(),
            ...this.taskInfo,
            executionBy: this.executionBy,
            userName: this.userName,
            executorPhone: this.executorPhone,
            sampleIdList: this.sampleIdList, // ["360822610101010432","360822479591047168"]
            sampleDetails: {
              tableData: this.$refs.addSampleList.tableData,
              type : this.$refs.addSampleList.type,
              group : this.$refs.addSampleList.group,
              groupName : this.$refs.addSampleList.groupName,
              checkedSeetingFields: this.$refs.addSampleList.checkedSeetingFields,
              checkBoxData: this.$refs.addSampleList.checkBoxData
            }
          })
            .then(res => {
              if (res.data.code != 0) {
                this.$message.error(res.data.msg)
                return
              }
              this.$message.success('添加成功');
              this.$emit('cancel')
            })
            .catch(err => {
              console.log(err)
            })
        } else {
          console.log('error submit!!')
          this.$message.error('您有未完成的输入')
          return false
        }
      })
    },
    // 监听input-number值的变化
    currentInputNumber(val, item, currentIndex) {
      const baseSettleRule = JSON.parse(JSON.stringify(this.taskInfo.settleRule))
      baseSettleRule.tiers.forEach((it, i, arr) => {
        if (i > currentIndex) {
          it.quantityUpperBound = arr[i - 1].quantityUpperBound + 1
        }
      })
      this.taskInfo.settleRule = {
        ...this.taskInfo.settleRule,
        tiers: baseSettleRule.tiers
      }
    },
    // 切换结算方式
    changeSettlementType(val) {
      this.$refs['taskInfo'].clearValidate()
      this.taskInfo = {
        ...this.taskInfo,
        settleMode: val,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      }
    },
    // 三种结算方式(添加/删除)
    handleSettlement(type, index) {
      console.log(type)
      if (type === 'add') {
        const validateArr = []
        this.taskInfo.settleRule.tiers.forEach((it, i) => {
          validateArr.push(`settleRule.tiers[${i}].quantityUpperBound`)
          validateArr.push(`settleRule.tiers[${i}].unitPriceYuan`)
        })
        let validFlag = false
        validateArr.forEach(item => {
          this.$refs['taskInfo'].validateField(
            validateArr,
            valid => (validFlag = valid ? false : true) // 定义是否通过表单验证
          )
        })
        console.log('validateArr:', validateArr)
        if (validFlag) {
          if (this.taskInfo.settleRule.tiers.length < 5) {
            const lastTiers = this.taskInfo.settleRule.tiers[this.taskInfo.settleRule.tiers.length - 1]
            const lastObj = { quantityUpperBound: lastTiers.quantityUpperBound, unitPriceYuan: lastTiers.unitPriceYuan }

            const flagDouble = Object.values(lastObj).includes(undefined)
            if (flagDouble) {
              this.$message.error('请完善表单项')
              return
            }

            const cloneLadderSettlement = this.taskInfo.settleRule.tiers
            cloneLadderSettlement.push({
              quantityLowerBound: undefined,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            })
            this.taskInfo.settleRule.tiers = cloneLadderSettlement
          } else {
            this.$message.error('最多只能添加5条数据')
          }
        } else {
          this.$message.error('请完善表单项')
        }
      } else if (type === 'remove') {
        const cloneLadderSettlement = this.taskInfo.settleRule.tiers

        this.taskInfo.settleRule.tiers = cloneLadderSettlement.filter((it, i) => index !== i)
      }
    },
    // 监听添加样本组件是否已经勾选数据
    selectionChangeEmit (val) {
      console.log('selectionChangeEmit',val)
      this.tableData = val
    }
  }
}
</script>

<style scoped lang="scss">
.d-title {
  display: flex;
  align-items: center;
  line-height: 18px;
  font-size: 18px;
  color: #303133;
}
.inputModel {
  width: 250px;
  height: auto;
  border: 1px solid rgb(220, 223, 230);
  border-radius: 5px;
}
.input_span {
  border: 1px solid rgb(233, 233, 235);
  background-color: rgb(244, 244, 245);
  border-radius: 5px;
  margin-left: 5px;
}
.icon_i {
  margin-left: 8px;
  cursor: pointer;
}
::v-deep .dialog-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .el-button--medium {
    margin-right: 0 12px;
  }
}
::v-deep .dialog-footer-rigt {
  justify-content: flex-end;
}
::v-deep .dialog_button {
  /*设置按钮样式排列 */
  display: flex;
  justify-content: space-between;
  // margin-top: -20px;
}
::v-deep .el-transfer-panel {
  width: 470px !important;
}
::v-deep .el-transfer__buttons {
  /*设置按钮样式排列 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-transfer__buttons {
  button:first-child {
    position: absolute;
    bottom: 195px;
    background: white;
    color: #409eff;
  }
}
.assignTask {
  .goback {
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }

  .visitor-info {
    display: flex;
    flex-direction: column;
    ::v-deep .el-form-item {
      margin: 20px 0;
    }
    ::v-deep .el-form--label-right {
      display: flex;
    }
  }
  ::v-deep .el-form,
  .el-form--label-right {
    width: 100%;
    justify-content: center;
  }
  .example-info {
  }
  .menu_example {
  }
  .task-info {
    .el-form {
      margin: 0 auto;
      .el-form-item {
        margin-bottom: 12px;
      }
      .el-form-input {
        width: 250px;
      }
    }
  }

  .task-info {
    margin-bottom: 0;
  }
  .desc {
    margin-top: 56px;
  }
  .submit-btn {
    margin-top: 60px;
    text-align: center;
  }
}
.elBody {
  display: flex;
  align-items: center;
}
.textarea {
  width: 530px;
  margin-right: 200px;
  margin-top: 160px;
  margin-left: 30px;
  position: relative;
}
.input_phone {
  // margin-left: 412px;
}
::v-deep .el-textarea__inner {
  height: calc(100vh - 424px);
  margin-top: -50px;
}
.top-title {
  @apply text-medium-x font-medium text-theme-black-850;
  height: 22px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0,0,0,0.85);
  letter-spacing: 0;
  line-height: 22px;
}
.bottom_btn {
  margin-left: 680px;
}
.task_example {
  font-size: 20px;
  font-weight: bold;
  color: rgb(217, 0, 27);
}
.elBtn {
  margin: 15px 0 0 420px;
}
.spTip {
  position: absolute;
  bottom: 0px;
  right: 360px;
  background: rgb(254, 240, 240);
  padding: 0px 20px;
  color: rgb(245, 108, 108);
  font-weight: bold;
}
.sppTip {
  font-size: 20px;
  padding: 0 5px;
}
.iconTip {
  color: rgb(245, 108, 108);
  margin-right: 8px;
}
.btn-footer {
  @apply h-16 flex items-center justify-end pr-6;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.settlementType-style .flex-box .pos-abs-box {
  position: absolute;
  display: flex;
  justify-content: flex-end;
  width: 90px;
  padding-right: 12px;
  i {
    content: '*';
    color: #e34152;
    margin-right: 4px;
  }
}
.settlementType-style{
  margin-top: 8px;
  margin-bottom: 16px;
  .settlement-tips{
    margin-left: 110px;
    &.left-0{
      margin-left: 0;
    }
  }
}
.settlementType-style .flex-settlement .el-form-item {
  margin-bottom: 0 !important;
}
.btn-box {
  @apply flex justify-center;
  padding: 10px;
  min-height: 106px;
  width: 230px;
  border-radius: 2px;
  cursor: pointer;
  line-height: 16px;
  position: relative;
  .position-checkbox{
    position: absolute;
    right: 0;
    top: -2px;
  }
  &.btn1 {
    border: 1px solid #cccccc;
  }
  &.btn2 {
    border: 1px solid #cccccc;
    margin-left: 12px;
  }
  &.btn1.btn-checked,
  &.btn2.btn-checked {
    background: rgba(39,117,232,0.10);
    border: 1px solid var(--theme-color) !important;
  }
  .tujian {
    border: 1px solid #FAAD14;
    border-radius: 8px;
    width: 34px;
    height: 16px;
    font-weight: 500;
    font-size: 12px;
  }
}
// .btn-checked div {
//   div {
//     color: #2775e8 !important;
//   }
//   i {
//     color: #2775e8 !important;
//   }
// }
.btn-box:hover {
  &.btn1,
  &.btn2 {
    background: rgba(39,117,232,0.10);
    border: 1px solid var(--theme-color) !important;
    // div {
    //   div {
    //     color: #2775e8 !important;
    //   }
    //   i {
    //     color: #2775e8 !important;
    //   }
    // }
  }
}
</style>